<template>
	<div id="body">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft animated" ata-wow-delay="0.4s">
							<h1>{{home}}</h1></div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight animated" ata-wow-delay="0.4s">
							<li>
								<router-link to="/index">{{lang == 1 ? '首页' : 'Home'}}</router-link>
							</li>
							<li class="active">
								<router-link to="/programme">{{home}}</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<div id="content">
			<section class="blog-section">
				<div class="container">
					<div class="row" id="blog">
						<!--Blog Section-->
						<div class="col-md-8 col-sm-7 col-xs-12">
							<article id="post-82" class="post-82 post type-post status-publish format-standard hentry category-uncategorized" data-wow-delay="0.4s" v-for="item in list">
								<div class="entry-meta">
									<span class="entry-date">
										<a href="javascript:;"><time datetime="">{{item.date}}</time></a>
									</span>
								</div>
								<header class="entry-header">
									<h3 class="entry-title"><router-link :to="{name:'article',params: { id: item.article_id }}">{{item.title}}</router-link></h3>
									<div class="entry-meta">
										<span class="author">{{lang == 1 ? '作者' : 'Author'}} <a rel="tag" href="javascript:;">{{item.author_name}}</a></span>
										<span class="cat-links">{{lang == 1 ? '在' : 'in'}}<a href="javascript:;" rel="category tag">{{item.category}}</a></span>
									</div>
								</header>
								<div class="entry-content">
									<figure class="wp-block-image size-large is-resized" style="display: block;">
										<img loading="lazy" :src="baseUrl + item.cover_image" alt="" class="wp-image-83" style="width: 100%;" />
										<figcaption class="text-content" v-html="item.content" style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;"></figcaption>
									</figure>
								</div>
							</article>
						</div>
						<!--/Blog Section-->
						<!--Sidebar Section-->
						<div class="col-md-4 col-sm-5 col-xs-12">
							<div class="sidebar">
								<aside id="search-1" class="widget widget_search wow fadeInDown animated" data-wow-delay="0.4s">
									<div class="section-header wow fadeInDown animated" data-wow-delay="0.4s">
										<h3 class="widget-title">Search</h3></div>
										<form method="get" id="searchform" class="search-form" action="" ref="form">
											<label><input type="search" class="search-field" :placeholder="lang == 1 ? '搜索' : 'Search'" v-model="search" /></label>
											<label><input type="button" class="search-submit" :value="lang == 1 ? '搜索' : 'Search'" @click="onSubmit"></label>
										</form>
								</aside>
								<aside id="recent-posts-1" class="widget widget_recent_entries wow fadeInDown animated" data-wow-delay="0.4s">
									<div class="section-header wow fadeInDown animated" data-wow-delay="0.4s">
										<h3 class="widget-title">{{lang == 1 ? '近期文章' : 'Latest Release' }}</h3></div>
									<ul>
										<li v-for="item in right">
											<router-link :to="{name:'article',params: { id: item.article_id }}">{{item.title}}</router-link>
										</li>
									</ul>

								</aside>
							</div>
						</div>
						<!--Sidebar Section-->
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import { getArticle } from '../api/api';
	export default {
		data() {
			return {
				baseUrl: 'http://admin.brlsea.org',
				search: '',
				right: [],
				list: [],
				home: ''
			};
		},
		props: ['lang'],
		methods: {
			onSubmit(){
				this.$router.push({
					name: 'search',
					params: {
						search: this.search
					}
				})
			},
			onGetArticleRight(){
				let that = this;
				getArticle({
					lang: this.lang,
					page: 1,
					size: 3
				}).then(res=>{
					if(res.code == 1) {
						that.right = res.data;
					}
				})
			},
			onGetArticle(){
				let that = this;
				getArticle({
					lang: this.lang,
					page: 1,
					size: 1000,
					keyword: this.search
				}).then(res=>{
					if(res.code == 1) {
						that.list = res.data;
					}
				})
			}
		},
		created() {
			this.onGetArticleRight();
			this.onGetArticle();
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
		}
	};
</script>

<style scoped="scoped">

</style>


// WEBPACK FOOTER //
// src/components/programme.vue